import MenteeStatusChip from 'components/Chips/MenteeStatusChip';
import { PageHeadContainer } from 'components/PageHead';
import { FC } from 'react';
import styled from 'styled-components';
import useSWR from 'swr';
import User from 'types/User';
import MenteeChart from '../MenteeChart';

export const PageTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  & h1 {
    font-weight: 500;
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }

  & p {
    margin-top: 0.75rem;
    font-size: 1rem;
    color: var(--gray-500);
  }
`;

const Head: FC = () => {
  const { data: user } = useSWR<User>('/auth/profile');
  return (
    <PageHeadContainer>
      <PageTitle>
        <h1>Mentorat</h1>
        {user?.menteeStatus === 'SIGNING_CHART' && (
          <>
            <MenteeStatusChip
              status="SIGNING_CHART"
              mentorshipStatus="ONGOING"
            />
            <p>Veuillez lire et signer la charte de bonne conduite</p>
          </>
        )}
      </PageTitle>
    </PageHeadContainer>
  );
};

const SignChart: FC = () => {
  return (
    <div>
      <Head />
      <MenteeChart />
    </div>
  );
};

export default SignChart;
